/* eslint-disable */
import settings from "../../../configs/settings";
import { Autocomplete, Box, Paper, TextField, Typography, Fab, Tooltip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { isNumeric } from "../../../project/utils/utils";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { getTarjetasDebito } from "../../../project/services/MedioCobroService";
//
// ################################################################################
//
const CobroTarjetaDebito = () => {
  const [valueACTarjetaDebito, setValueACTarjetaDebito] = useState({
    id: "",
    label: "",
  });

  const [inputValueACTarjetaDebito, setInputValueACTarjetaDebito] =
    useState("");

  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    setExpandedAccordionMediosDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);

  const [tarjetasDebito, setTarjetasDebito] = useState([]);

  const {
    idTarjetaDebito,
    descripcionTarjetaDebito,
    importe,
    numeroLote,
    numeroCupon,
  } = medioDeCobro;
  const _importeAnterior = medioDeCobro.importe;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetasDebito();
    setValueACTarjetaDebito({
      id: idTarjetaDebito,
      label: descripcionTarjetaDebito,
    });
  }, []);
  //
  // ################################################################################
  //
  const loadTarjetasDebito = async () => {
    const response = await getTarjetasDebito();
    if (response.ok) {
      let _tarjetasDebito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion = item.marca_tarjeta.toUpperCase() + " - " + item.banco_entidad.toUpperCase() +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "");

        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuentoTarjetaDebito: item.porcentaje_descuento,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasDebito.push(_tarjeta);
      });
      setTarjetasDebito(_tarjetasDebito);
    } else {
      setTarjetasDebito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setMedioDeCobro({
      ...medioDeCobro,
      idTarjetaDebito: valueACTarjetaDebito.id,
      descripcionTarjetaDebito: valueACTarjetaDebito.label,
      porcentajeDescuentoTarjetaDebito: valueACTarjetaDebito.id
        ? tarjetasDebito.find((item) => item.id === valueACTarjetaDebito.id)
          .porcentajeDescuentoTarjetaDebito
        : 0,
    });
  }, [valueACTarjetaDebito]);
  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {
    // valido los datos del cobro

    if (inputValueACTarjetaDebito === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una Tarjeta de Débito",
      });
      setShowMessage(true);
      return;
    }

    if (numeroLote === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de lote",
      });
      setShowMessage(true);
      return;
    }

    if (numeroCupon === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de cupón",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe mayor a 0",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar un importe mayor a 0",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("tarjeta-debito");
  };
  //
  // ################################################################################
  //
  const asignaRestoACobrar = () => {
    setMedioDeCobro({
      ...medioDeCobro,
      importe: restoACobrar,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Tarjeta de Débito
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Autocomplete
            id="tarjetasDebitoOptions"
            size="small"
            value={valueACTarjetaDebito}
            onChange={(event, newValue) => {
              setValueACTarjetaDebito(newValue);
            }}
            inputValue={inputValueACTarjetaDebito}
            onInputChange={(event, newInputValue) => {
              setInputValueACTarjetaDebito(newInputValue);
            }}
            options={tarjetasDebito}
            renderInput={(params) => <TextField {...params} label="Tarjeta de Débito" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="numeroLote"
            label="Número de Lote"
            variant="outlined"
            size="small"
            name="numeroLote"
            value={numeroLote}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="numeroCupon"
            label="Número de Cupón"
            variant="outlined"
            size="small"
            name="numeroCupon"
            value={numeroCupon}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="importe"
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
              style: { textAlign: "right" },
            }}
          />
          <Tooltip title="asignar el resto a cobrar">
            <Fab
              sx={{ ml: 1, mr: 1 }}
              color="secondary"
              aria-label="add"
              size="small"
              onClick={asignaRestoACobrar}
            >
              <PriceChangeOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>

        <Box sx={{ p: 1 }}>
          <Tooltip title="agregar cobranza">
            <Fab
              sx={{ mr: 1 }}
              color="primary"
              aria-label="add"
              size="small"
              onClick={actualizaCobro}
            >
              <CheckOutlinedIcon />
            </Fab>
          </Tooltip>

          <Tooltip title="cancelar">
            <Fab
              sx={{ mr: 1 }}
              color="outlined"
              aria-label="add"
              size="small"
              onClick={cancelaCobro}
            >
              <CloseOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Paper>
    </>
  );
};

export default CobroTarjetaDebito;
